import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["theme", "size", "icon"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { clsx } from 'clsx';
import { getRoundButtonTheme } from '../../themes';
import styles from '../../styles/roundButton.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
const RoundButtonComponent = /*#__PURE__*/React.forwardRef(function RoundedButton(_ref, ref) {
  let {
      theme = 'fill_light',
      size = 'M',
      icon
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const isLightTheme = theme === 'fill_light';
  const themeClasses = getRoundButtonTheme(theme);
  const buttonClasses = clsx(styles['button'], styles[size], themeClasses['button']);
  const preparedIcon = /*#__PURE__*/React.cloneElement(icon, {
    color: isLightTheme ? 'icon-secondary-default' : 'icon-on-bright-default'
  });
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({}, rest), {}, {
    className: buttonClasses,
    ref: ref,
    children: /*#__PURE__*/_jsx("div", {
      className: styles['icon'],
      children: preparedIcon
    })
  }));
});

/**
 * Компонент круглой кнопки с иконкой. <br />
 * Компонет имеет настройки тем, размеров, умеет отображать иконки. Кроме того кнопки меняют свое отображение в завсимости от пользовательских действий.
 *
 * [Ссылка на макет](https://www.figma.com/design/Ien9YZjKIXwWM2WYHyXuvS/%F0%9F%8C%90-Button?node-id=2002-2310&t=ubORfzH7Xy6blqiy-0)
 */
export const RoundButton = /*#__PURE__*/React.memo(RoundButtonComponent);